import { Button, Icon, theme } from '@dasa-health/components-react'
import React, { useState } from 'react'
import { SignUpModal } from 'redesign/components/molecules/SignUpModal'
import { MiscOutlineQuestioncircle } from '@dasa-health/icons'
import { ModalDataContainer } from '../style'

export const BiologicalSexModalButton = () => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <>
            <div>
                <Button
                    borderRadius="pill"
                    data-testid="close-modal"
                    onClick={() => setIsOpen(true)}
                    size="compact"
                    type="button"
                    variant="tertiary"
                >
                    <Icon color={theme.colors.black} size={26}>
                        <MiscOutlineQuestioncircle />
                    </Icon>
                </Button>
            </div>
            {isOpen && (
                <ModalDataContainer>
                    <SignUpModal
                        setShowModal={() => {
                            setIsOpen(v => !v)
                        }}
                        showModal={isOpen}
                        title="Por que queremos saber sobre seu sexo biológico?"
                    >
                        <p>
                            Através do sexo biológico consigo identificar os parâmetros corretos na realização de exames, plano de
                            saúde e impactos no resultado de laudos médicos.
                        </p>
                    </SignUpModal>
                </ModalDataContainer>
            )}
        </>
    )
}
